import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';

import { onlyMoney } from 'hooks/Pipe';
import { wsUpdate } from 'services/WService';
import { Visibility } from '@material-ui/icons';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import CategoryGroup from './CategoryGroup';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const InputField = (props) => {
  return (
    <TextField
      {...props}
      style={{ marginTop: 0, marginBottom: '3px' }}
      margin="normal"
      size="small"
      fullWidth
      inputProps={{ style: { textAlign: props.type === 'text' ? 'left' : 'right' } }}
    />
  );
};

export default function Groups({ incentive, data = [], groupType, showNotify, reload }) {
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [providerSelect, setProviderSelect] = useState(false);

  return (
    <>
      <ModalFull title="Categorías de proveedor" open={openModal} setOpen={setOpenModal}>
        <CategoryGroup
          provider={
            incentive?.providers?.find((item) => item.LineNum === providerSelect.LineNum) || []
          }
          showNotify={showNotify}
          reload={reload}
          groupType={groupType.type}
        />
      </ModalFull>

      <div
        style={{
          marginBottom: '15px',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderImage: 'linear-gradient(to top, white, #972fb0) 1',
          borderRadius: '2px'
        }}
      >
        <Table className={classes.table} size="small" aria-label="tabla de proveedores con grupos">
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={8}
                style={{ backgroundColor: '#972fb0', color: 'white' }}
                align="center"
              >
                {groupType.label}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ver Categ.</TableCell>
              <TableCell>Código prov.</TableCell>
              <TableCell>Nombre proveedor</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell width="150">% Peso</TableCell>
              <TableCell width="150">Rango min</TableCell>
              <TableCell width="150">Rango máx.</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((prov, i) => (
              <ListProvider
                key={i}
                providerSelect={providerSelect}
                prov={prov}
                setOpenModal={setOpenModal}
                setProviderSelect={setProviderSelect}
                reload={reload}
                showNotify={showNotify}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

const ListProvider = (props) => {
  const { prov, providerSelect, setOpenModal, setProviderSelect, reload, showNotify } = props;

  const [providerVal, setProviderVal] = useState(prov);

  const handlechange = (e) => {
    setProviderVal({ ...providerVal, [e.target.name]: e.target.value });
  };

  async function updateProv(e) {
    if (!!prov && prov[e.target.name] == e.target.value) return;

    let response = await wsUpdate(`com/incentive/${prov.com_incentive_id}/provider`, prov.LineNum, {
      [e.target.name]: e.target.value
    });

    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (prov.LineNum) setProviderVal(prov);
  }, [prov]);

  return (
    <TableRow>
      <TableCell>
        <Button
          justIcon
          round
          simple
          color={providerSelect.LineNum == prov.LineNum ? 'warning' : 'primary'}
          style={{ height: '0px' }}
          onClick={() => {
            setOpenModal(true);
            setProviderSelect(prov);
          }}
        >
          <Visibility />
        </Button>
      </TableCell>
      <TableCell>{prov.CardCode}</TableCell>
      <TableCell>{prov.CardName}</TableCell>
      <TableCell>
        <InputField
          type="text"
          name="description"
          value={providerVal.description || ''}
          onBlur={updateProv}
          onChange={handlechange}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number"
          name="percentage_weight"
          value={providerVal.percentage_weight || ''}
          onBlur={updateProv}
          onChange={handlechange}
          onKeyPress={onlyMoney}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number"
          name="min_range"
          value={providerVal.min_range || ''}
          onBlur={updateProv}
          onChange={handlechange}
          onKeyPress={onlyMoney}
          inputProps={{ min: 0, max: prov.max_range, step: 0.01 }}
        />
      </TableCell>
      <TableCell>
        <InputField
          type="number"
          name="max_range"
          value={providerVal.max_range || ''}
          onBlur={updateProv}
          onChange={handlechange}
          onKeyPress={onlyMoney}
          inputProps={{ min: prov.min_range, step: 0.01 }}
        />
      </TableCell>
      <TableCell align="center">
        <ButtonDelete
          entity={`com/incentive/${prov.com_incentive_id}/provider`}
          id={prov.LineNum}
          reload={reload}
          style={{ height: '0px' }}
        />
      </TableCell>
    </TableRow>
  );
};
